import administrations, { AdministrationsState } from 'services/administrations/reducer'
import app, { AppState } from 'services/app/reducer'
import authentication, { AuthenticationState } from 'services/authentication/reducer'
import birthdayWidget, { BirthdayWidgetState } from 'services/birthdayWidget/reducer'
import childBooking, { ChildBookingState } from 'services/booking/childBooking/reducer'
import childFundings, { ChildFundingsState } from 'services/booking/childFundings/reducer'
import childProducts, { ChildProductsState } from 'services/booking/childProducts/reducer'
import periods, { PeriodsState } from 'services/booking/periods/reducer'
import childBacsDetails, { ChildBacsDetailsState } from 'services/childBacsDetails/reducer'
import childNotes, { ChildNotesState } from 'services/childNotes/reducer'
import childrenSignedUpReport, { ChildrenSignedUpReportState } from 'services/childrenSignedUpReport/reducer'
import childrenStartingReport, { ChildrenStartingReportState } from 'services/childrenStartingReport/reducer'
import closureDayTypes, { ClosureDayTypesState } from 'services/closureDayTypes/reducer'
import dailyDiaryMedications, { DailyDiaryMedicationsState } from 'services/dailyDiaryMedications/reducer'
import device from 'services/device/reducer'
import formBuilderSettings, { FormBuilderSettingsState } from 'services/formBuilderSettings/reducer'
import integrationFees, { IntegrationFeesState } from 'services/integrationFees/reducer'
import absenceReasons from 'services/legacy/absenceReasons/reducer'
import agedDebt from 'services/legacy/agedDebt/reducer'
import assessmentTracker from 'services/legacy/assessmentTracker/reducer'
import auth from 'services/legacy/auth/reducer'
import authenticationLogs from 'services/legacy/authenticationLogs/reducer'
import balanceAdjustments from 'services/legacy/balanceAdjustments/reducer'
import carerChildRelations from 'services/legacy/carerChildRelations/reducer'
import carers from 'services/legacy/carers/reducer'
import childBankDetails from 'services/legacy/child/legacyBankDetails/reducer'
import child from 'services/legacy/child/reducer'
import childAbsences from 'services/legacy/childAbsences/reducer'
import childAdhocSessions from 'services/legacy/childAdhocSessions/reducer'
import childBulkFunding from 'services/legacy/childBulkFunding/reducer'
import childDailyDiary from 'services/legacy/childDailyDiary/reducer'
import childDiscounts from 'services/legacy/childDiscounts/reducer'
import childExtraItems from 'services/legacy/childExtraItems/reducer'
import childFrameworkProgress from 'services/legacy/childFrameworkProgress/reducer'
import childFunding from 'services/legacy/childFunding/reducer'
import childFundingSessionSet from 'services/legacy/childFundingSessionSet/reducer'
import childMoves from 'services/legacy/childMoves/reducer'
import childObservations from 'services/legacy/childObservations/reducer'
import childRegisters from 'services/legacy/childRegisters/reducer'
import childrenLeavingReport from 'services/legacy/childrenLeavingReport/reducer'
import childrenSessions from 'services/legacy/childrenSessions/reducer'
import childSessions from 'services/legacy/childSessions/reducer'
import cohortTracking from 'services/legacy/cohortTracking/reducer'
import contracts from 'services/legacy/contracts/reducer'
import creditNotes from 'services/legacy/creditNotes/reducer'
import newDailyDiary from 'services/legacy/dailyDiary/reducer'
import dailyDiaryActivities from 'services/legacy/dailyDiaryActivities/reducer'
import dailyDiaryBottles from 'services/legacy/dailyDiaryBottles/reducer'
import dailyDiaryFoods from 'services/legacy/dailyDiaryFoods/reducer'
import dailyDiaryNappies from 'services/legacy/dailyDiaryNappies/reducer'
import dailyDiarySleeps from 'services/legacy/dailyDiarySleeps/reducer'
import dailyDiaryToiletTraining from 'services/legacy/dailyDiaryToiletTraining/reducer'
import deposits from 'services/legacy/deposits/reducer'
import deviceTokens from 'services/legacy/deviceTokens/reducer'
import enquiryActivities from 'services/legacy/enquiries/activities/reducer'
import enquiries from 'services/legacy/enquiries/reducer'
import enquiryReports from 'services/legacy/enquiries/reports/reducer'
import enquirySettings from 'services/legacy/enquiries/settings/reducer'
import enquiryStatusTypes from 'services/legacy/enquiries/statusTypes/reducer'
import enquiryViewings from 'services/legacy/enquiries/viewings/reducer'
import ethnicities from 'services/legacy/ethnicities/reducer'
import files from 'services/legacy/files/reducer'
import financeBadDebtReport from 'services/legacy/financeBadDebtReport/reducer'
import financeBalanceReport from 'services/legacy/financeBalanceReport/reducer'
import financeCreditNotesReport from 'services/legacy/financeCreditNotesReport/reducer'
import financeDepositsReport from 'services/legacy/financeDepositsReport/reducer'
import financeFundingReport from 'services/legacy/financeFundingReport/reducer'
import financeRevenuePerAgeReport from 'services/legacy/financeRevenuePerAgeReport/reducer'
import financeRevenuePerRoomReport from 'services/legacy/financeRevenuePerRoomReport/reducer'
import foodMenu from 'services/legacy/foodMenu/reducer'
import foodTypes from 'services/legacy/foodTypes/reducer'
import formativeReports from 'services/legacy/formativeReports/reducer'
import frameworkProgressLevels from 'services/legacy/frameworkProgressLevels/reducer'
import frameworks from 'services/legacy/frameworks/reducer'
import fundingTypes from 'services/legacy/fundingTypes/reducer'
import homeObservations from 'services/legacy/homeObservations/reducer'
import injuries from 'services/legacy/injuries/reducer'
import invoicePayments from 'services/legacy/invoicePayments/reducer'
import invoices from 'services/legacy/invoices/reducer'
import leaveNotes from 'services/legacy/leaveNotes/reducer'
import leaveTypes from 'services/legacy/leaveTypes/reducer'
import membershipRegisters from 'services/legacy/membershipRegisters/reducer'
import memberships from 'services/legacy/memberships/reducer'
import membershipsLeaves from 'services/legacy/membershipsLeaves/reducer'
import membershipsShifts from 'services/legacy/membershipsShifts/reducer'
import montessoriCategories from 'services/legacy/montessoriCategories/reducer'
import monthlyFteChangeReport from 'services/legacy/monthlyFteChangeReport/reducer'
import newsletterRecipients from 'services/legacy/newsletterRecipients/reducer'
import newsletters from 'services/legacy/newsletters/reducer'
import nextMontessoriActivities from 'services/legacy/nextMontessoriActivities/reducer'
import nextSteps from 'services/legacy/nextSteps/reducer'
import nurseryDiscounts from 'services/legacy/nurseryDiscounts/reducer'
import nurseryExtraItems from 'services/legacy/nurseryExtraItems/reducer'
import nurseryFrameworkRelations from 'services/legacy/nurseryFrameworkRelations/reducer'
import nurseryPaymentTypes from 'services/legacy/nurseryPaymentTypes/reducer'
import observationFeedback from 'services/legacy/observationFeedback/reducer'
import observations from 'services/legacy/observations/reducer'
import occupancy from 'services/legacy/occupancy/reducer'
import organizationSessions from 'services/legacy/organizationSessions/reducer'
import organizationTerms from 'services/legacy/organizationTerms/reducer'
import paymentReminderTags from 'services/legacy/paymentReminderTags/reducer'
import register from 'services/legacy/register/reducer'
import registerStatistics from 'services/legacy/registerStatistics/reducer'
import relations from 'services/legacy/relations/reducer'
import requestedExtraSessions from 'services/legacy/requestedExtraSessions/reducer'
import roomMove from 'services/legacy/roomMove/reducer'
import newRooms from 'services/legacy/rooms/reducer'
import staffLogs from 'services/legacy/staffLogs/reducer'
import supportedCurrency from 'services/legacy/supportedCurrency/reducer'
import supportedLocale from 'services/legacy/supportedLocale/reducer'
import transactions from 'services/legacy/transactions/reducer'
import upload from 'services/legacy/upload/reducer'
import medicationForms, { MedicationFormsState } from 'services/medicationForms/reducer'
import milkReport, { MilkReportState } from 'services/milkReport/reducer'
import needsAttentionWidget, { NeedsAttentionWidgetState } from 'services/needsAttentionWidget/reducer'
import nurseries, { NurseriesState } from 'services/nurseries/reducer'
import nurseryAcademicYears, { NurseryAcademicYearsState } from 'services/nurseryAcademicYears/reducer'
import nurseryConsumables, { NurseryConsumablesState } from 'services/nurseryConsumables/reducer'
import nurseryContext, { NurseryContextState } from 'services/nurseryContext/reducer'
import nurseryFunding, { NurseryFundingState } from 'services/nurseryFunding/reducer'
import nurseryIntegrations, { NurseryIntegrationsState } from 'services/nurseryIntegrations/reducer'
import nurserySessions, { NurserySessionsState } from 'services/nurserySessions/reducer'
import organization from 'services/organization/reducer'
import periodTimes, { PeriodTimesState } from 'services/periodTimes/reducer'
import nurseryConsumablesV3, { NurseryConsumablesV3State } from 'services/product/nurseryConsumablesV3/reducer'
import nurseryDiscountsV3, { NurseryDiscountsV3State } from 'services/product/nurseryDiscountsV3/reducer'
import nurseryFundingV3, { NurseryFundingV3State } from 'services/product/nurseryFundingV3/reducer'
import nurseryItem, { NurseryItemState } from 'services/product/nurseryItem/reducer'
import nurserySessionsV3, { NurserySessionsV3State } from 'services/product/nurserySessionsV3/reducer'
import productPriceGroups, { ProductPriceGroupsState } from 'services/product/productPriceGroups/reducer'
import registrationForms, { RegistrationFormsState } from 'services/registrationForms/reducer'
import reviews, { ReviewsState } from 'services/reviews/reducer'
import router, { RouterState } from 'services/router/reducer'
import shell, { ShellState } from 'services/shell/reducer'
import startersAndLeaversWidget, { StartersAndLeaversWidgetState } from 'services/startersAndLeaversWidget/reducer'
import subdomain, { SubdomainState } from 'services/subdomain/reducer'
import supportedReligions, { SupportedReligionsState } from 'services/supportedReligions/reducer'
import supportedTimezones, { SupportedTimezonesState } from 'services/supportedTimezones/reducer'
import users, { UsersState } from 'services/users/reducer'
import modal, { ModalState } from 'services/utils/modal/reducer'
import snackbar, { SnackbarState } from 'services/utils/snackbar/reducer'
import versionControl, { VersionControlState } from 'services/versionControl/reducer'
import viewingsStatisticsWidget, { ViewingsStatisticsWidgetState } from 'services/viewingsStatisticsWidget/reducer'

import generateInvoices from 'module/Finance/FinanceGenerateInvoices/service/reducer'

export interface RootState {
  absenceReasons: any
  administrations: AdministrationsState
  agedDebt: any
  app: AppState
  assessmentTracker: any
  auth: any
  authentication: AuthenticationState
  authenticationLogs: any
  balanceAdjustments: any
  birthdayWidget: BirthdayWidgetState
  carerChildRelations: any
  carers: any
  child: any
  childAbsences: any
  childAdhocSessions: any
  childBacsDetails: ChildBacsDetailsState
  childBankDetails: any
  childBooking: ChildBookingState
  childBulkFunding: any
  childDailyDiary: any
  childDiscounts: any
  childExtraItems: any
  childFrameworkProgress: any
  childFunding: any
  childFundingSessionSet: any
  childFundings: ChildFundingsState
  childMoves: any
  childNotes: ChildNotesState
  childObservations: any
  childProducts: ChildProductsState
  childRegisters: any
  childSessions: any
  childrenLeavingReport: any
  childrenSessions: any
  childrenSignedUpReport: ChildrenSignedUpReportState
  childrenStartingReport: ChildrenStartingReportState
  closureDayTypes: ClosureDayTypesState
  cohortTracking: any
  contracts: any
  creditNotes: any
  dailyDiaryActivities: any
  dailyDiaryBottles: any
  dailyDiaryFoods: any
  dailyDiaryMedications: DailyDiaryMedicationsState
  dailyDiaryNappies: any
  dailyDiarySleeps: any
  dailyDiaryToiletTraining: any
  deposits: any
  device: any
  deviceTokens: any
  enquiries: any
  enquiryActivities: any
  enquiryReports: any
  enquirySettings: any
  enquiryStatusTypes: any
  enquiryViewings: any
  ethnicities: any
  files: any
  financeBadDebtReport: any
  financeBalanceReport: any
  financeCreditNotesReport: any
  financeDepositsReport: any
  financeFundingReport: any
  financeRevenuePerAgeReport: any
  financeRevenuePerRoomReport: any
  foodMenu: any
  foodTypes: any
  formBuilderSettings: FormBuilderSettingsState
  formativeReports: any
  frameworkProgressLevels: any
  frameworks: any
  fundingTypes: any
  generateInvoices: any
  homeObservations: any
  injuries: any
  integrationFees: IntegrationFeesState
  invoicePayments: any
  invoices: any
  leaveNotes: any
  leaveTypes: any
  medicationForms: MedicationFormsState
  membershipRegisters: any
  memberships: any
  membershipsLeaves: any
  membershipsShifts: any
  milkReport: MilkReportState
  modal: ModalState
  montessoriCategories: any
  monthlyFteChangeReport: any
  needsAttentionWidget: NeedsAttentionWidgetState
  newDailyDiary: any
  newRooms: any
  newsletterRecipients: any
  newsletters: any
  nextMontessoriActivities: any
  nextSteps: any
  nurseries: NurseriesState
  nurseryAcademicYears: NurseryAcademicYearsState
  nurseryConsumables: NurseryConsumablesState
  nurseryConsumablesV3: NurseryConsumablesV3State
  nurseryContext: NurseryContextState
  nurseryDiscounts: any
  nurseryDiscountsV3: NurseryDiscountsV3State
  nurseryExtraItems: any
  nurseryFrameworkRelations: any
  nurseryFunding: NurseryFundingState
  nurseryFundingV3: NurseryFundingV3State
  nurseryIntegrations: NurseryIntegrationsState
  nurseryItem: NurseryItemState
  nurseryPaymentTypes: any
  nurserySessions: NurserySessionsState
  nurserySessionsV3: NurserySessionsV3State
  observationFeedback: any
  observations: any
  occupancy: any
  organization: any
  organizationSessions: any
  organizationTerms: any
  paymentReminderTags: any
  periodTimes: PeriodTimesState
  periods: PeriodsState
  productPriceGroups: ProductPriceGroupsState
  register: any
  registerStatistics: any
  registrationForms: RegistrationFormsState
  relations: any
  requestedExtraSessions: any
  reviews: ReviewsState
  roomMove: any
  router: RouterState
  routing: any
  shell: ShellState
  snackbar: SnackbarState
  staffLogs: any
  startersAndLeaversWidget: StartersAndLeaversWidgetState
  subdomain: SubdomainState
  supportedCurrency: any
  supportedLocale: any
  supportedReligions: SupportedReligionsState
  supportedTimezones: SupportedTimezonesState
  transactions: any
  upload: any
  users: UsersState
  versionControl: VersionControlState
  viewingsStatisticsWidget: ViewingsStatisticsWidgetState
}

export default {
  absenceReasons,
  administrations,
  agedDebt,
  app,
  assessmentTracker,
  auth,
  authentication,
  authenticationLogs,
  balanceAdjustments,
  birthdayWidget,
  carerChildRelations,
  carers,
  child,
  childAbsences,
  childAdhocSessions,
  childBacsDetails,
  childBankDetails,
  childBooking,
  childBulkFunding,
  childDailyDiary,
  childDiscounts,
  childExtraItems,
  childFrameworkProgress,
  childFunding,
  childFundingSessionSet,
  childFundings,
  childMoves,
  childNotes,
  childObservations,
  childProducts,
  childRegisters,
  childSessions,
  childrenLeavingReport,
  childrenSessions,
  childrenSignedUpReport,
  childrenStartingReport,
  closureDayTypes,
  cohortTracking,
  contracts,
  creditNotes,
  dailyDiaryActivities,
  dailyDiaryBottles,
  dailyDiaryFoods,
  dailyDiaryMedications,
  dailyDiaryNappies,
  dailyDiarySleeps,
  dailyDiaryToiletTraining,
  deposits,
  device,
  deviceTokens,
  enquiries,
  enquiryActivities,
  enquiryReports,
  enquirySettings,
  enquiryStatusTypes,
  enquiryViewings,
  ethnicities,
  files,
  financeBadDebtReport,
  financeBalanceReport,
  financeCreditNotesReport,
  financeDepositsReport,
  financeFundingReport,
  financeRevenuePerAgeReport,
  financeRevenuePerRoomReport,
  foodMenu,
  foodTypes,
  formBuilderSettings,
  formativeReports,
  frameworkProgressLevels,
  frameworks,
  fundingTypes,
  generateInvoices,
  homeObservations,
  injuries,
  integrationFees,
  invoicePayments,
  invoices,
  leaveNotes,
  leaveTypes,
  medicationForms,
  membershipRegisters,
  memberships,
  membershipsLeaves,
  membershipsShifts,
  milkReport,
  modal,
  montessoriCategories,
  monthlyFteChangeReport,
  needsAttentionWidget,
  newDailyDiary,
  newRooms,
  newsletterRecipients,
  newsletters,
  nextMontessoriActivities,
  nextSteps,
  nurseries,
  nurseryAcademicYears,
  nurseryConsumables,
  nurseryConsumablesV3,
  nurseryContext,
  nurseryDiscounts,
  nurseryDiscountsV3,
  nurseryExtraItems,
  nurseryFrameworkRelations,
  nurseryFunding,
  nurseryFundingV3,
  nurseryIntegrations,
  nurseryItem,
  nurseryPaymentTypes,
  nurserySessions,
  nurserySessionsV3,
  observationFeedback,
  observations,
  occupancy,
  organization,
  organizationSessions,
  organizationTerms,
  paymentReminderTags,
  periodTimes,
  periods,
  productPriceGroups,
  register,
  registerStatistics,
  registrationForms,
  relations,
  requestedExtraSessions,
  reviews,
  roomMove,
  router,
  shell,
  snackbar,
  staffLogs,
  startersAndLeaversWidget,
  subdomain,
  supportedCurrency,
  supportedLocale,
  supportedReligions,
  supportedTimezones,
  transactions,
  upload,
  users,
  versionControl,
  viewingsStatisticsWidget,
}
